import * as moment from "moment";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";

export class RightShipInspectionHelper {

    /**
     * Get 'validUntil' text
     * @param dateFrom Valid until from date
     * @param dateTo Valid until to date
     */
    public getValidUntilText(dateFrom: Date, dateTo: Date) : string {
        let textToReturn : string = "";

        const dateFromClone = CloneHelper.clone(dateFrom);
        const dateToClone = CloneHelper.clone(dateTo);

        const diff =  this.diffMonthsDays(dateFromClone, dateToClone);

        const monthOffset = diff.months;
        const dayOffset = diff.days;
        
        textToReturn = monthOffset > 0 ? `${monthOffset} ${monthOffset > 1 ? 'months' : 'month'}` : "";
        textToReturn += (dayOffset > 0 && monthOffset > 0)?  ' ': ''; 
        textToReturn += dayOffset > 0 ? `${dayOffset} ${dayOffset > 1 ? 'days' : 'day'}` : monthOffset != 0 ? "" : "0 days";
        
        return textToReturn
    }

    /**
     * Calculate difference between two days in months and dates
     * @param dateFrom
     * @param dateTo
     */
     diffMonthsDays(dateFrom: Date, dateTo: Date) {
        //Formats dates to remove time
        const dateToClone = moment(moment(dateTo).format('YYYY-MM-DD'));
        const dateFromClone = moment(moment(dateFrom).format('YYYY-MM-DD'));
        //Difference in months
        const months = dateToClone.diff(dateFromClone, 'months');
        dateFromClone.add(months, 'months');
        
        //Difference in days
        const days = dateToClone.diff(dateFromClone, 'days', true);
       
        return { months, days };
    }

    public monthsBetween(dateFrom: Date, dateTo: Date) {
        const dateFromClone = new Date(dateFrom);
        const dateToClone =  new Date(dateTo);
        return dateToClone.getMonth() - dateFromClone.getMonth() +
          (12 * (dateToClone.getFullYear() - dateFromClone.getFullYear()));
    }
}